module.exports = __webpack_public_path__ + "static/media/new-york-49.d1985e18.jpg";